import "./App.css";
import TodoList from "./components/TodoList";

function App() {
  return (
    <div>
      <TodoList />
    </div>
  );
}

export default App;
